import Portfolio from '../portfolio';

/**
 * Create the action
 */

const { thunk, request, success, error } = Portfolio.update((data, fetch) => {

    if(data.attachEvidence === true) {
        return fetch.post('/portfolio/attach-evidence', data);
    } else if(data.detachEvidence === true) {
        return fetch.post('/portfolio/detach-evidence', data);
    }
    else if(data.updateOrder === true) {
        return fetch.post('/portfolio/update-order', data);
    }

    data['_method'] = 'PUT';
    return fetch.post(`/portfolios/${data.id}`, data);
});

/**
 * Export the components
 */

export { thunk as default };
export { request, success, error };
